export let company = {
  title: 'SKP24 Connect Firma',
  description:
    '<strong>W tym miejscu zamówisz dodatkową aplikację 24/7, dzięki której w dowolnym momencie wystawisz faktury online, masz bieżący wgląd w dane swojej firmy oraz wprowadzisz do aplikacji wiele innych dokumentów.</strong> ',
  web: 'https://www.ksiega-podatkowa.pl/skp24-connect-firma/dla-kogo',
  package_info:
    'Wybierz odpowiednią dla swoich potrzeb ilość miesięcy, w jakich chcesz korzystać z usługi.' +
    '</br><span class="font-italic info-text">Uwaga! W ciągu trwania abonamentu zawsze możesz rozszerzyć abonament o kolejne miesiące!</span>',
  free_title: 'Miesiąc próbny',
  free_price: 'Abonament miesięczny',
  free_info:
    'Chcesz przekonać się, czy ta usługa jest dla Ciebie? Zamów bezpłatny miesiąc próbny.',
};

export let accountant = {
  title: 'SKP24 Connect Biuro',
  description:
    '<strong>W tym miejscu zamówisz dodatkową aplikację 24/7, która pozwala na automatyczną, wzajemną wymianę dokumentów pomiędzy Twoim biurem rachunkowym a Twoimi klientami.</strong> ',
  web: 'https://www.ksiega-podatkowa.pl/skp24-connect-biuro/dlaczego-warto',
  package_info:
    'Abonamenty sprzedawane są na czas określony, liczony w pełnych miesiącach lub na jeden rok.',
  free_title: 'WERSJA BEZPŁATNA<br> zamów 2 m-ce za 0 zł',
  free_price: 'Abonament 2-miesięczny',
  free_info:
    'Chcesz przekonać się, czy ta usługa jest dla Ciebie?\n' +
    'Zamów bezpłatne 2 miesiące próbne.\n' +
    'Otrzymasz dostęp do usługi w ramach pakietu START.\n',
};
